import { Col, Row } from 'react-bootstrap';
import { HeadingDesc, SectionHeadingLarge } from '../Headings';
import ReviewBy from '../reviewBy/ReviewBy';
import StatusWithoutBackground from '../status/StatusWithoutBackground';
import Qoutes from '../qoutes/Qoutes';
import './articleDetail.css';

function ArticleDetail(props) {
  const {
    articleTitle,
    articleReviewImage,
    articleReviewByName,
    articleWrittenByName,
    articleUpdateOn,
    articleImg,
    articleDesc,
    qouteHeading,
    qouteDesc,
    tagData
  } = props;
  return (
    <section className="articleDetail">
      <Row>
        <Col md={9}>
          <div className="content">
            <SectionHeadingLarge text={articleTitle} />
            <ReviewBy
              reviewImg={articleReviewImage}
              reviewBy={articleReviewByName}
              writtenBy={articleWrittenByName}
              updateOn={articleUpdateOn}
            />
            <StatusWithoutBackground
              status={tagData?.map(({ tagText, tagLink }) => ({
                statusText: tagText,
                link: tagLink
              }))}
              // status={[
              //   { statusText: tagText, link: tagLink }
              // { statusText: 'Symptoms', link: '/' },
              // { statusText: 'Treatment Options', link: '/' },
              // { statusText: 'Home Remedies', link: '/' },
              // { statusText: 'Diagnosing GERD', link: '/' },
              // { statusText: 'GERD Vs. Heartburn', link: '/' },
              // { statusText: 'Causes', link: '/' },
              // { statusText: 'Dietary Triggers', link: '/' },
              // { statusText: 'GERD And Other Conditions', link: '/' },
              // { statusText: 'GERD In Infants', link: '/' },
              // { statusText: 'Potential Complications', link: '/' },
              // { statusText: 'Takeaway', link: '/' }
              // ]}
            />
            <div className="articleImg">
              {articleImg && <img src={articleImg || ''} alt="articleImg" />}
            </div>
            <Qoutes heading={qouteHeading} desc={qouteDesc} />
            <HeadingDesc text={articleDesc} />
          </div>
        </Col>
        <Col md={3}>
          <div className="add">
            <h3>Ad Space</h3>
          </div>
        </Col>
      </Row>
    </section>
  );
}

export default ArticleDetail;
